import { MainPageBundleNameList, MainPagePicBGList } from '@/src/utils/guideBundleNameList';
import KNB from '@wmfe/mach-pro-knb';

const SLCommon = Mach.requireModule('SLCommon');
const SLCompass = Mach.requireModule('SLCompass');
const SLMPI18N = Mach.requireModule('Intl');

// 二级页头图直出缓存AB实验:
const WMABTest = Mach.requireModule('SLABStrategy');

// Horn开关控制是否请求首页头图接口
const Horn = Mach.requireModule('SLCHorn');
const hornConfig = Horn?.getAppConfig?.();

const pickUpDefaultScene = 'pick_up_header_pic_scene'; //自定义自取默认specialScene的key
const SLStorageKey = 'sec_page_pic_cache'; //数据存储的key

/**
 * 获取二级页秒开优化实验数据
 * @param bundle 可选
 * @returns obj
 */
export const getFFPABExp = (bundle?: string) => {
  const bundleName = bundle || Mach.env.bundleName;
  //  实验：自取频道页 + 一人食
  if (bundleName === MainPageBundleNameList.PickUp || bundleName === MainPageBundleNameList.FixedPrice) {
    const strategy = WMABTest?.getRealTimeStrategy?.({
      sceneKey: 'sailor_c_homepage_secpage_ffp',
      groupKey: 'sailor_c_homepage_secpage_pic_cache_prod_exp1'
    });
    return strategy;
    //  实验：频道页
  } else if (bundleName === MainPageBundleNameList.ChannelList) {
    const strategy = WMABTest?.getRealTimeStrategy?.({
      sceneKey: 'sailor_c_homepage_secpage_ffp',
      groupKey: 'sailor_c_homepage_secpage_ffp_exp2'
    });
    return strategy;
  } else {
    return {};
  }
};

/**
 * 是否命中二级页秒开优化实验
 * @param bundle 可选
 * @returns boolean
 */
export const isHitPicCacheFFPAB = (bundle?: string) => {
  if (!hornConfig?.openPicCache) {
    return false;
  }
  const bundleName = bundle || Mach.env.bundleName;
  let result = false;
  /**
   * 按地区判断自取落地页是否使用头图直出，
   * HK 地区有轮播所以默认关闭
   * SA 地区默认开启
   * 其它地区默认开启
   */
  if (bundleName === MainPageBundleNameList.PickUp) {
    const { pickupHeadPicDirectSwitch } = hornConfig || {};
    return pickupHeadPicDirectSwitch ?? true;
  }
  //  实验：一人食
  if (bundleName === MainPageBundleNameList.FixedPrice) {
    result = (getFFPABExp()?.expKey === 'C' || getFFPABExp()?.expKey === 'D');
    //  实验：频道页
  } else if (bundleName === MainPageBundleNameList.ChannelList) {
    result = (getFFPABExp()?.expKey?.includes?.('B'));
  }
  // console.log('🐱实验命中了没🐱', result);
  return result;
};

/**
 * 存储bundle、场景name和头图url的映射
 * @param bundleName 包名
 * @param picObjStr 头图ObjStr
 * @param specialScene 唯一场景id
 */
export const setSecPicCache = (bundleName: string, picObjStr: string, specialScene?: string) => {
  if (!isHitPicCacheFFPAB(bundleName)) {
    return;
  }
  const locale = SLMPI18N?.getCurrentLocaleInfo().locale;
  const { region: compassRegion } = SLCompass.getCompassInfo() || {};
  if (bundleName === MainPageBundleNameList.PickUp) {
    specialScene = pickUpDefaultScene;
  }
  const picKey = `${compassRegion}_${locale}_${bundleName}_${specialScene}`;
  const timeStamp = Date.now();
  let pagePicCache = {
    ts: timeStamp
  };
  const pagePicCacheSTR = SLCommon.getStorage({ key: SLStorageKey });
  if (pagePicCacheSTR) {
    pagePicCache = JSON.parse(pagePicCacheSTR);
  }
  pagePicCache[picKey] = picObjStr;
  SLCommon.setStorage({
    key: SLStorageKey,
    value: JSON.stringify(pagePicCache)
  });
};

/**
 * 根据包和场景id获取对应头图缓存
 * @param bundleName 包名
 * @param specialScene 场景id
 * @returns 头图url对象
 */
export const getSecPicCache = (bundleName: string, specialScene?: string) => {
  if (!isHitPicCacheFFPAB(bundleName)) {
    return;
  }
  const locale = SLMPI18N?.getCurrentLocaleInfo().locale;
  const { region: compassRegion } = SLCompass.getCompassInfo() || {};
  if (bundleName === MainPageBundleNameList.PickUp) {
    specialScene = pickUpDefaultScene;
  }
  const picKey = `${compassRegion}_${locale}_${bundleName}_${specialScene}`;
  const curTS = Date.now();
  let pagePicCache;
  const pagePicCacheSTR = SLCommon.getStorage({
    key: SLStorageKey,
  });
  if (pagePicCacheSTR) {
    try {
      pagePicCache = JSON.parse(pagePicCacheSTR);
    } catch (error) {
      return {};
    }
  } else {
    return {};
  }

  if (pagePicCache) {
    let picCache = {};
    try {
      picCache = JSON.parse(pagePicCache[picKey]);
    } catch (error) {
      return {};
    }
    const lastTS = pagePicCache.ts;
    // 超过3天清除
    if (lastTS && (curTS - lastTS) > 3 * 24 * 60 * 60 * 1000) {
      pagePicCache = {
        ts: curTS
      };
      SLCommon.setStorage({
        key: SLStorageKey,
        value: JSON.stringify(pagePicCache)
      });
      picCache = {};
    }
    return picCache;
  }
};

/**
 * 秒开数据上报
 */
export const reportPicCacheABTest = (otherTag = {}) => {
  if (getFFPABExp()?.expKey) {
    // 秒开率
    KNB?.use('ffp.addCustomTags', {
      pagePath: Mach.env.isIOS ? 'SLMPBaseViewController' : '',
      customTags: {
        ...(otherTag || {}),
        __SLFFPExpKey: getFFPABExp()?.expKey,
        __SLCachePicRequestType: hornConfig?.openPicCache, //是否请求首页接口
        __SLCachePicDisableLightSweep: '1'
      },
    });
  }
};

/**
 * 处理秒开接口的头图数据
 * @param data 接口数据
 */
export const handleSecPicAPIData = (response: any) => {
  if (response?.dataList?.length > 0) {
    const picList = response?.dataList;
    picList?.forEach((item: any) => {
      const bundleName = item?.bundleName;
      const specialScene = item?.specialScene;
      const componentList = item?.componentList?.length
        ? item.componentList.filter((component: any) => (
          component?.dataList?.length > 0 && MainPagePicBGList.includes(component.frontComponentId)
        ))
        : [];
      componentList.forEach((component) => {
        if (component?.dataList?.length > 0) {
          const picApiList = component.dataList.map((data: any) => (data?.type === 0 ? data : []));
          if (picApiList && picApiList.length > 0) {
            const picApiObj = picApiList[0];
            const picObj = {
              picUrl: picApiObj?.data?.url,
              aspectRatio: picApiObj?.data?.ratio
            };
            setSecPicCache(bundleName, JSON.stringify(picObj), specialScene);
          }
        }
      });
    });
  }
};
